export const CLEAR_COMPARE_TEXT = "Очистить список";